import { render, staticRenderFns } from "./editBat.vue?vue&type=template&id=4a40a589&scoped=true&"
import script from "./editBat.vue?vue&type=script&lang=js&"
export * from "./editBat.vue?vue&type=script&lang=js&"
import style0 from "./editBat.vue?vue&type=style&index=0&id=4a40a589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40a589",
  null
  
)

export default component.exports